<template>
  <cms-media />
</template>

<script>
export default {
  components: {
    CmsMedia: () => import('@/components/cms/media/CmsMedia'),
  },
}
</script>